import { Expose } from "class-transformer";
import { IsDateString, IsDefined, IsNumber, IsString } from "class-validator";

export class PrivacyPolicy {
  @Expose()
  @IsDefined()
  @IsNumber()
  id!: number;

  @Expose()
  @IsDefined()
  @IsNumber()
  version!: number;

  @Expose()
  @IsDefined()
  @IsString()
  status!: string;

  @Expose()
  @IsDefined()
  @IsString()
  text!: string;

  @Expose()
  @IsDefined()
  @IsDateString()
  created!: string;

  @Expose()
  @IsDefined()
  @IsDateString()
  updated!: string;
}
